// extracted by mini-css-extract-plugin
export default {"wrapper":"WXMh05o1OKLef6BXXds1","label":"hCG6QGCZreqWTgAd0C_w"};